/* Rose Candy Renk Kitabı 2026 — product facts. Generated by tools/build_data.py from the Shopify Admin read-back of 2026-10-16; do not edit by hand. */
window.RC = window.RC || {};
RC.products = {
 "el": {
  "handle": "easy-lipstick",
  "title": "Mat Ruj",
  "vendor": "Rose Candy",
  "size": "7 g",
  "sizeSource": "Trendyol",
  "shades": [
   {
    "name": "Rose",
    "sku": "RSC05",
    "barcode": "8684215702878",
    "key": "el-rose",
    "hex": "#9D5B64"
   },
   {
    "name": "Nude",
    "sku": "RSC06",
    "barcode": "8684215702885",
    "key": "el-nude",
    "hex": "#A76163"
   },
   {
    "name": "Velvet",
    "sku": "RSC07",
    "barcode": "8684215702892",
    "key": "el-velvet",
    "hex": "#623A35"
   }
  ]
 },
 "gl": {
  "handle": "lipgloss",
  "title": "Dudak Parlatıcısı",
  "vendor": "Rose Candy",
  "size": "5 ml",
  "sizeSource": "Trendyol",
  "shades": [
   {
    "name": "Brownie Bite",
    "sku": "RSC10",
    "barcode": "8684215703493",
    "key": "gl-brownie-bite",
    "hex": "#5A3C36"
   },
   {
    "name": "Spiced Cookie",
    "sku": "RSC11",
    "barcode": "8684215703509",
    "key": "gl-spiced-cookie",
    "hex": "#8A4130"
   },
   {
    "name": "Pink Donut",
    "sku": "RSC12",
    "barcode": "8684215703516",
    "key": "gl-pink-donut",
    "hex": "#E54764"
   },
   {
    "name": "Cherry Pie",
    "sku": "RSC13",
    "barcode": "8684215703523",
    "key": "gl-cherry-pie",
    "hex": "#993A4A"
   },
   {
    "name": "Candy Apple",
    "sku": "RSC14",
    "barcode": "8684215703530",
    "key": "gl-candy-apple",
    "hex": "#D8251B"
   }
  ]
 },
 "ml": {
  "handle": "matte-lipgloss",
  "title": "Mat Likit Ruj",
  "vendor": "Rose Candy",
  "size": "5 ml",
  "sizeSource": "Trendyol",
  "shades": [
   {
    "name": "Vampire Kiss",
    "sku": "RSC33",
    "barcode": "8684215703790",
    "key": "ml-vampire-kiss",
    "hex": "#B3262B"
   },
   {
    "name": "Dusty Rose",
    "sku": "RSC34",
    "barcode": "8684215703813",
    "key": "ml-dusty-rose",
    "hex": "#8F6669"
   },
   {
    "name": "Cherry Bite",
    "sku": "RSC35",
    "barcode": "8684215703837",
    "key": "ml-cherry-bite",
    "hex": "#640E14"
   },
   {
    "name": "Hot Biscuit",
    "sku": "RSC36",
    "barcode": "8684215703806",
    "key": "ml-hot-biscuit",
    "hex": "#7B4A4D"
   },
   {
    "name": "Honey Beige",
    "sku": "RSC37",
    "barcode": "8684215703820",
    "key": "ml-honey-beige",
    "hex": "#A25E5E"
   }
  ]
 },
 "tint": {
  "handle": "lip-cheek-tint",
  "title": "Dudak ve Yanak Renklendiricisi",
  "vendor": "Rose Candy",
  "size": "5 ml",
  "sizeSource": "Trendyol",
  "shades": [
   {
    "name": "Mango",
    "sku": "RSC31",
    "barcode": "8684215703738",
    "key": "tint-mango",
    "hex": "#E16A50"
   },
   {
    "name": "Mercan",
    "sku": "RSC32",
    "barcode": "8684215703745",
    "key": "tint-mercan",
    "hex": "#CA6B6D"
   }
  ]
 },
 "hl": {
  "handle": "highlighter",
  "title": "Aydınlatıcı",
  "vendor": "Rose Candy",
  "size": "12 ml",
  "sizeSource": "Trendyol",
  "shades": [
   {
    "name": "Cotton",
    "sku": "RSC16",
    "barcode": "8684215703554",
    "key": "hl-cotton",
    "hex": "#CB7D71"
   },
   {
    "name": "Champagne",
    "sku": "RSC17",
    "barcode": "8684215703561",
    "key": "hl-champagne",
    "hex": "#DE9F86"
   }
  ]
 },
 "powder": {
  "handle": "setting-powder",
  "title": "Sabitleyici Pudra",
  "vendor": "Rose Candy",
  "size": "15 g",
  "sizeSource": "Trendyol",
  "shades": [
   {
    "name": "Transparent",
    "sku": "RSC18",
    "barcode": "8684215703585",
    "key": "powder-transparent",
    "hex": "#E5C7BC"
   },
   {
    "name": "Pink",
    "sku": "RSC19",
    "barcode": "8684215703578",
    "key": "powder-pink",
    "hex": "#D4A2B8"
   }
  ]
 },
 "lb": {
  "handle": "liquid-blusher",
  "title": "Likit Allık",
  "vendor": "Rose Candy",
  "size": "5 ml",
  "sizeSource": "Trendyol",
  "shades": [
   {
    "name": "Dusty Rose",
    "sku": "RSC20",
    "barcode": "8684215703592",
    "key": "lb-dusty-rose",
    "hex": "#926063"
   },
   {
    "name": "Coral Dream",
    "sku": "RSC21",
    "barcode": "8684215703608",
    "key": "lb-coral-dream",
    "hex": "#DB595F"
   },
   {
    "name": "Scarlet Glow",
    "sku": "RSC22",
    "barcode": "8684215703615",
    "key": "lb-scarlet-glow",
    "hex": "#DC5056"
   },
   {
    "name": "Mocha Glow",
    "sku": "RSC23",
    "barcode": "8684215703622",
    "key": "lb-mocha-glow",
    "hex": "#92746A"
   },
   {
    "name": "Candy Pop",
    "sku": "RSC24",
    "barcode": "8684215703639",
    "key": "lb-candy-pop",
    "hex": "#B96777"
   }
  ]
 },
 "cb": {
  "handle": "cream-blusher",
  "title": "Krem Allık",
  "vendor": "Rose Candy",
  "size": "8 g",
  "sizeSource": "Trendyol",
  "shades": [
   {
    "name": "Mocha Kiss",
    "sku": "RSC25",
    "barcode": "8684215703646",
    "key": "cb-mocha-kiss",
    "hex": "#A96E60"
   },
   {
    "name": "Ruby Glow",
    "sku": "RSC26",
    "barcode": "8684215703653",
    "key": "cb-ruby-glow",
    "hex": "#C63A3C"
   },
   {
    "name": "Desert Nude",
    "sku": "RSC27",
    "barcode": "8684215703660",
    "key": "cb-desert-nude",
    "hex": "#C1736E"
   },
   {
    "name": "Pink Bloom",
    "sku": "RSC28",
    "barcode": "8684215703677",
    "key": "cb-pink-bloom",
    "hex": "#F3769B"
   },
   {
    "name": "Coral Sunset",
    "sku": "RSC29",
    "barcode": "8684215703684",
    "key": "cb-coral-sunset",
    "hex": "#F87562"
   }
  ]
 },
 "fdn": {
  "handle": "foundation-24h",
  "title": "Gün Boyu Kalıcı Fondöten",
  "vendor": "Rose Candy",
  "size": "50 ml",
  "sizeSource": "etiket",
  "shades": [
   {
    "name": "Ivory",
    "sku": "RSC42",
    "barcode": "8684215703974",
    "key": "fdn-ivory",
    "hex": "#EBCEB5"
   },
   {
    "name": "Light",
    "sku": "RSC38",
    "barcode": "8684215703950",
    "key": "fdn-light",
    "hex": "#DBB28E"
   },
   {
    "name": "Medium",
    "sku": "RSC43",
    "barcode": "8684215703967",
    "key": "fdn-medium",
    "hex": "#E2B288"
   }
  ]
 },
 "conc": {
  "handle": "concealer",
  "title": "Kapatıcı",
  "vendor": "Rose Candy",
  "size": "5 ml",
  "sizeSource": "Trendyol",
  "shades": [
   {
    "name": "Light",
    "sku": "RSC44",
    "barcode": "8684215703981",
    "key": "conc-light",
    "hex": "#E6BD9E"
   },
   {
    "name": "Medium",
    "sku": "RSC41",
    "barcode": "8684215703998",
    "key": "conc-medium",
    "hex": "#D5AA8C"
   },
   {
    "name": "Dark",
    "sku": "RSC45",
    "barcode": "8684215704063",
    "key": "conc-dark",
    "hex": "#CF9874"
   }
  ]
 },
 "brow": {
  "handle": "wonderbrow",
  "title": "Wonderbrow Kaş Maskarası",
  "vendor": "Rose Candy",
  "size": "5 ml",
  "sizeSource": "Trendyol",
  "shades": [
   {
    "name": "Light Brown",
    "sku": "RSC49",
    "barcode": "8684215704070",
    "key": "brow-light-brown",
    "hex": "#9E7B67"
   },
   {
    "name": "Milky Brown",
    "sku": "RSC46",
    "barcode": "8684215704087",
    "key": "brow-milky-brown",
    "hex": "#8D6D59"
   },
   {
    "name": "Medium Brown",
    "sku": "RSC47",
    "barcode": "8684215704094",
    "key": "brow-medium-brown",
    "hex": "#6B554C"
   },
   {
    "name": "Dark Brown",
    "sku": "RSC48",
    "barcode": "8684215704100",
    "key": "brow-dark-brown",
    "hex": "#40312F"
   }
  ]
 },
 "caps-aa": {
  "handle": "anti-aging-capsule-serum",
  "title": "Yaşlanma Karşıtı Kapsül Serum",
  "vendor": "Rose Candy",
  "size": "20 × 0,5 ml",
  "sizeSource": "site",
  "sku": "RSC01",
  "barcode": "8684215702786"
 },
 "caps-e": {
  "handle": "vitamin-e-capsule-serum",
  "title": "E Vitamini Kapsül Serum",
  "vendor": "Rose Candy",
  "size": "20 × 0,5 ml",
  "sizeSource": "site",
  "sku": "RSC02",
  "barcode": "8684215702793"
 },
 "caps-c": {
  "handle": "vitamin-c-capsule-serum",
  "title": "C Vitamini Kapsül Serum",
  "vendor": "Rose Candy",
  "size": "20 × 0,5 ml",
  "sizeSource": "site",
  "sku": "RSC03",
  "barcode": "8684215702809"
 },
 "caps-ret": {
  "handle": "retinol-capsule-serum",
  "title": "Retinol Kapsül Serum",
  "vendor": "Rose Candy",
  "size": "20 × 0,5 ml",
  "sizeSource": "site",
  "sku": "RSC04",
  "barcode": "8684215702816"
 },
 "micellar": {
  "handle": "micellar-cilt-temizleme-suyu",
  "title": "Miseller Cilt Temizleme Suyu",
  "vendor": "Rose Candy",
  "size": "250 ml",
  "sizeSource": "etiket",
  "sku": "RSC08",
  "barcode": "8684215703295"
 },
 "foam": {
  "handle": "face-cleansing-foam",
  "title": "Yüz Temizleme Köpüğü",
  "vendor": "Rose Candy",
  "size": "150 ml",
  "sizeSource": "etiket",
  "sku": "RSC52",
  "barcode": "8684215704339"
 },
 "spf": {
  "handle": "spf-50-waterproof-sunscreen-cream",
  "title": "SPF 50+ Suya Dayanıklı Güneş Koruyucu",
  "vendor": "Rose Candy",
  "size": "100 ml",
  "sizeSource": "etiket",
  "sku": "RSC54",
  "barcode": "8684215704360"
 },
 "bronzer": {
  "handle": "shimmer-bronzer-oil",
  "title": "Işıltılı Bronzlaştırıcı Yağ",
  "vendor": "Rose Candy",
  "size": "100 ml",
  "sizeSource": "etiket",
  "sku": "RSC53",
  "barcode": "8684215704377"
 },
 "primer": {
  "handle": "make-up-primer",
  "title": "Makyaj Bazı",
  "vendor": "Rose Candy",
  "size": "30 ml",
  "sizeSource": "etiket",
  "sku": "RSC30",
  "barcode": "8684215703752"
 },
 "spray": {
  "handle": "makyaj-sabitleyici-sprey",
  "title": "Makyaj Sabitleyici Sprey",
  "vendor": "Rose Candy",
  "size": "100 ml",
  "sizeSource": "etiket",
  "sku": "RSC40",
  "barcode": "8684215703943"
 },
 "puff": {
  "handle": "setting-powder-sponge",
  "title": "Pudra Süngeri",
  "vendor": "Rose Candy",
  "size": "",
  "sizeSource": "",
  "sku": "RSC50",
  "barcode": "8684215704193"
 },
 "sponge": {
  "handle": "foundation-sponge",
  "title": "Fondöten Süngeri",
  "vendor": "Rose Candy",
  "size": "",
  "sizeSource": "",
  "sku": "RSC51",
  "barcode": "8684215704186"
 },
 "palette": {
  "handle": "far-paleti",
  "title": "Far Paleti",
  "vendor": "Rose Candy",
  "size": "12 × 2,6 g = 31,2 g",
  "sizeSource": "etiket",
  "sku": "RSC09",
  "barcode": "8684215703769"
 },
 "browset": {
  "handle": "kas-sabitleyici",
  "title": "Kaş Sabitleyici",
  "vendor": "Rose Candy",
  "size": "6,5 ml",
  "sizeSource": "Trendyol",
  "sku": "RSC39",
  "barcode": "8684215704001"
 },
 "bag": {
  "handle": "holografik-seffaf-fermuarli-makyaj-cantasi",
  "title": "Holografik Şeffaf Fermuarlı Makyaj Çantası",
  "vendor": "Rose Candy",
  "size": "26 × 20,5 × 5,5 cm",
  "sizeSource": "site",
  "sku": "RSC61",
  "barcode": "8684215704896"
 }
};
